import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {connect} from 'react-redux'
import { compose } from 'redux'
import enhanceWithClickOutside from 'react-click-outside';
import { Box, X } from 'react-feather';

import { cart } from '../actions'
import CartMonth from '../components/CartMonth'

class Cart extends Component {
  handleClickOutside(event) {
    if (this.props.cartStatus === 'show') {
      this.props.hideCart()
    }
  }

  checkMonth = (month) => {
    return this.props.cart.some(x => x.month === month.id)
  }

  render() {
    return (
      <div className={"Cart-overlay " + this.props.cartStatus}>
        <div className="Cart">
          <div className="Cart-top">
            <h2 className="title-medium">Översikt</h2>
            <Box />
          </div>
          <div className="Cart-close" onClick={this.props.hideCart}>
            <p>Stäng</p>
            <X />
          </div>
          {
            this.props.months.map((item, index) => {
              return (
                this.checkMonth(item)
                ?
                <CartMonth cart={this.props.cart} key={index} {...item}
                  reduceQuantity={this.props.reduceQuantity}
                  addQuantity={this.props.addQuantity} />
                :
                null
              )
            })
          }
          <p className="Cart-warning">
            Du betalar inte allt med en gång. Betalning sker endast i samband med leverans för valda månader. Du
            får då en länk innan vi skickar varorna som du måste godkänna via Klarna.
          </p>
          {
            this.props.approved
            ?
            null
            :
            <p className="Cart-warning red">
              Det måste minst ingå två vinlådor i ett abonnemang
            </p>
          }
          {
            this.props.isAuthenticated
            ?
              this.props.approved
              ?
              <button className="Cart-btn" onClick={this.props.saveCart}>
                Spara
              </button>
              :
              null
            :
              this.props.approved
              ?
              <Link to="/kassa" onClick={this.props.hideCart} className="Cart-btn">
                Checka Ut
              </Link>
              :
              null
          }
          <div className="Cart-bottom-align">
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cart: state.cart,
    months: state.months.months,
    isAuthenticated: state.auth.isAuthenticated,
    firstCheckout: state.auth.firstCheckout,
    approved: state.shop.approved
  }
}

const mapDispatchToProps = dispatch => {
  return {
    addQuantity: (product, month) => {
      return dispatch(cart.addQuantity(product, month));
    },
    reduceQuantity: (product_id, month) => {
      return dispatch(cart.reduceQuantity(product_id, month))
    }
  }
}

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  enhanceWithClickOutside
)(Cart);



// WEBPACK FOOTER //
// ./src/containers/Cart.jsx